import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { Menu } from '../components/Menu';
export function MenuPage() {
  const {
    t
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0,
    filter: 'blur(4px)'
  }} animate={{
    opacity: 1,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    filter: 'blur(4px)'
  }} transition={{
    duration: 0.6,
    ease: [0.4, 0, 0.2, 1]
  }} data-id="element-487">
      <PageHeader title={t.menu.title} subtitle={t.menu.subtitle} backgroundImage="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200" data-id="element-488" />

      <div className="bg-cream bg-sand-texture pt-16 pb-6 text-center px-6" data-id="element-489">
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="max-w-2xl mx-auto text-dark/50 font-light text-[15px] leading-[1.9]" data-id="element-490">
          {t.menu.intro}
        </motion.p>
      </div>

      <Menu data-id="element-491" />

      {/* CTA */}
      <section className="py-24 bg-warmWhite warm-glow text-center px-6" data-id="element-492">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-493">
          <p className="text-dark/45 font-light text-[15px] mb-10 max-w-md mx-auto leading-[1.9]" data-id="element-494">
            {t.home.ctaSubtitle}
          </p>
          <Link to="/reservations" className="inline-block px-11 py-4 bg-navy text-white hover:bg-navy-light transition-all duration-500 ease-elegant text-[11px] tracking-[0.15em] uppercase font-medium hover:shadow-elegant" data-id="element-495">
            {t.nav.bookNow}
          </Link>
        </motion.div>
      </section>
    </motion.div>;
}